<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 p-1 ">
      <h2 class="mb-0 main-title">Checklist Templates</h2>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-md btn-primary fs-11 fw-normal text-white hover-white" @click="openCreateModal('createModal')">
         <i class="fa fa-plus fs-11 hover-white"></i>  Add New Template
        </button>
        
      </div>
    </div>
    
    <!-- Filters Bar -->
    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger hover-white">
        <span class="material-symbols-outlined fs-6">undo</span> Reset
      </button>
    </div>

    <!-- Dropdown Template -->
    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>
   
    <div class="card p-1 bg-white">
      <!-- Create Modal -->
      <FormModal ref="createModal" title="Create New Template" id="create_template_form_modal">
        <CreateTemplate ref="CreateTemplateForm" @created="onCreated" @close="closeCreateModal('createModal')" />
      </FormModal>

      <!-- Edit Modal -->
      <FormModal ref="editModal" title="Edit Template" id="edit_template_form_modal">
        <EditTemplate ref="EditTemplateForm" @updated="onUpdated" @close="closeEditModal" />
      </FormModal>

      <!-- Loading State -->
      <LoadingBar v-if="loading" message="Loading templates..." />

      <!-- templates Table -->
      <div v-else class="table-wrapper ">
        <ListTable>
          <thead>
            <tr>
              <th @click="sortBy('name')" class="sortable">
                 Template <i :class="getSortIcon('name')"></i>
              </th>
              
               <th @click="sortBy('doc_no')" class="sortable">
                Doc No <i :class="getSortIcon('doc_no')"></i>
              </th>

               <th @click="sortBy('description')" class="sortable">
                Description <i :class="getSortIcon('description')"></i>
              </th>
              <th @click="sortBy('created_at')" class="sortable">
                Created At <i :class="getSortIcon('created_at')"></i>
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="template in sortedData" :key="template.id">
              <td>
                 <div class="mb-0">
                {{ template.name }}
              </div>
              <div class="mt-0">
                <small class="text-muted">#{{ template.doc_no }}</small>
              </div>
              </td>
              <td>{{ template.doc_no }}</td>
              <td>{{ $limit(template.description, 40, '...') }}</td>
              <td>{{ template.created_at }}</td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fas fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li><button class="dropdown-item" @click="$router.push(`/template/builder/${template.external_id}`)">
                      Builder
                    </button></li>
                    <li><button class="dropdown-item" @click="editTemplate(template)">
                      Edit
                    </button></li>
                    <li><button class="dropdown-item" @click="duplicate(template.external_id)">
                      Duplicate
                    </button></li>
                    <li><button class="dropdown-item text-danger" @click="deleteTemplate(template.id)">
                      Delete
                    </button></li>
                  </ul>
                </div>

              </td>
            </tr>
            <tr v-if="templates.length === 0">
              <td colspan="5" class="text-center">No Templates found</td>
            </tr>

          </tbody>
        </ListTable>
        
      </div>

      <!-- Pagination -->
      <Pagination :pagination="pagination" @page-change="changePage" />

    </div>
  </div>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateTemplate from '@/views/Template/CreateTemplate.vue'
import EditTemplate from '@/views/Template/EditTemplate.vue'
import ListTable from '@/components/utils/ListTable.vue'


export default {
  name: 'templateList',
  components: {
    Pagination,
    LoadingBar,
    FormModal,
    CreateTemplate,
    EditTemplate,
    ListTable,
  },
  data() {
    return {
      templates: [],
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false,
      filterManager: null,
      sortColumn: 'name',
      sortOrder: 'asc',
      currentFilters: {},
      editingTemplate: null,
    }
  },
  computed: {
    sortedData() {
      let result = [...this.templates];

      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];

          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';

          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },
  },
  mounted() {
    this.fetchList()
    this.$nextTick(() => {
      setTimeout(() => {
        this.initFilters();
      }, 100);
    });
  },
  methods: {
    openCreateModal(ref) {
      if (this.$refs[ref]) {
        this.$refs[ref].showModal()
      }
      if (this.$refs.CreateTemplateForm) {
        this.$refs.CreateTemplateForm.resetForm()
      }
    },

    closeCreateModal(ref) {
      if (this.$refs[ref]) {
        this.$refs[ref].closeModal()
      }
    },

    closeEditModal() {
      if (this.$refs.editModal) {
        this.$refs.editModal.closeModal()
      }
      this.editingTemplate = null
    },

    async onCreated() {
      this.pagination.current_page = 1
      await this.fetchList()
    },

    async onUpdated() {
      this.pagination.current_page = 1
      await this.fetchList()
      this.closeEditModal()
    },

    editTemplate(template) {
      this.editingTemplate = template
      this.$nextTick(() => {
        if (this.$refs.editModal) {
          this.$refs.editModal.showModal()
          setTimeout(() => {
            if (this.$refs.EditTemplateForm && this.editingTemplate) {
              this.$refs.EditTemplateForm.setTemplateData(this.editingTemplate)
            }
          }, 200)
        }
      })
    },

    async duplicate(id) {
      if(!confirm('Are you sure you want to duplicate this template?')) {
        return
      }
      this.loading = true

      const result = await form_api_submit({
        url: 'template/duplicate/' + id,
        method: 'POST',
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        // this.$toast('Template duplicated successfully!', true)
        this.pagination.current_page = 1
        await this.fetchList()
      }

      this.loading = false
    },

    async deleteTemplate(id) {
      if(!confirm('Are you sure you want to delete this template?')) {
        return
      }
      this.loading = true

      const result = await form_api_submit({
        url: 'template/delete/' + id,
        method: 'DELETE',
        show_success_toast: true,
        show_error_toast: true,
      })

      if (result.success) {
        // this.$toast('Template deleted successfully!', true)
        this.pagination.current_page = 1
        await this.fetchList()
      }

      this.loading = false
    },

    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          {
            key: "name",
            label: "Name",
            type: "input",
            placeholder: "Filter by Name"
          },
          {
            key: "doc_no",
            label: "Doc No",
            type: "input",
            placeholder: "Filter by Doc No"
          }
        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },

    applyFilters(activeFilters) {
      this.currentFilters = { ...activeFilters };
      this.pagination.current_page = 1;
      this.fetchList();
    },

    resetPagination() {
      this.pagination.current_page = 1;
      this.fetchList();
    },

    resetAllFilters() {
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      }
      this.currentFilters = {};
      this.sortColumn = 'name';
      this.sortOrder = 'asc';
      this.pagination.current_page = 1;
      this.fetchList();
    },

    async fetchList() {
      this.loading = true

      const payload = {
        page: this.pagination.current_page,
        ...this.currentFilters
      }

      const result = await form_api_submit({
        url: 'template/list',
        method: 'GET',
        data: payload,
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        console.log(result);
        this.templates = result.data.list
        this.pagination = result.data.pagination
      }

      this.loading = false
    },

    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      this.fetchList()
    },

    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },
  }
}
</script>

<style scoped>
.page-link {
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #667eea;
  border-color: #667eea;
}

img {
  object-fit: cover;
}

/* Filters Wrapper */
.filters-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
  padding: 8px 0;
}

/* .filters-wrapper .filters-bar {
  flex: 1;
} */

/* .filters-wrapper .btn {
  white-space: nowrap;
  font-size: 12px;
  padding: 4px 12px;
} */

.sortable {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.sortable:hover {
  background-color: #f8f9fa;
}

/* Table styling */
.table-wrapper {
  overflow-x: auto;
}

:deep(table) {
  width: 100%;
  border-collapse: collapse;
}

:deep(th) {
  background-color: #f8f9fa;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  border-bottom: 1px solid #dee2e6;
}

:deep(td) {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}

:deep(tr:hover) {
  background-color: #f8f9fa;
}

/* Dropdown styling */
.dropdown-menu {
  font-size: 12px;
  min-width: 140px;
}

.dropdown-item {
  font-size: 12px;
  padding: 6px 16px;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

/* Responsive */
@media (max-width: 768px) {
  :deep(th),
  :deep(td) {
    padding: 8px 12px;
  }
  
  .filters-wrapper {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filters-wrapper .btn {
    align-self: flex-end;
  }
}
</style>